export default function getLocalDateFromString(str) {
  if (str) {
    const date = new Date(str);
    return date.toLocaleDateString('en-US');
  }
  return '';
}
